import { createReducer } from "@reduxjs/toolkit";

import { initialState, setKanbanLanes, setCandidateStages, setGroupedSubStages } from "../Actions/kanbanBoardActions";

import type { KanbanBoardState } from "../Actions/kanbanBoardActions";

export const kanbanBoardReducer = createReducer<KanbanBoardState>(initialState, (builder) => {
    builder.addCase(setKanbanLanes, (state, action) => {
        state.KanbanLanes = action.payload;
    });
    builder.addCase(setCandidateStages, (state, action) => {
        state.CandidateStages = action.payload;
    });
    builder.addCase(setGroupedSubStages, (state, action) => {
        state.GroupedSubStages = action.payload;
    });
});